export default "__VITE_ASSET__B$pu9_nE__"